/// <reference path="../../../typings/browser.d.ts" />
/// <reference path="../../../customtypings/selectize/selectize.d.ts" />

namespace Application.Controllers {
    'use strict';

    import Utils = Common.Utils;


    export interface IModalResult {
        sim: Models.ISIM;
        newRemainingData: number;
    }

    export interface ISIMModalScope extends ng.IScope {
        title: string;
        sim: Models.ISIM;
        simPlans: Models.SimPlan[];
        setInitialData: boolean;
        selectedPlan: Models.SimPlan;
        selectedDataUnit: string;
        modalClose: () => void;
        modalSave: () => void;
        loadSelectize: () => void;
        billingCycleOptions: Object[];
        lastDayChecked: boolean;
        loadBillingSelectize: () => void;
        loadPlanSelectize: () => void;
        loadDataUnitSelectize: () => void;
        disableBillingSelect: () => void;
        selectedData: Models.IDataRemaining;
        initialDataToBytes: (bytes: number) => number;
        dataToBytes: () => number;
    }

    /**
     * SIMModalController class
     */
    export class SIMModalController {
        public static templateURL: string = "decorators/modals/sim-modal.html";
        public static ID: string = "#id-sim-modal";
        public static $name: string = "SIMModalController";
        public static $inject: string[] = ['$scope',
                                           'close',
                                           'title',
                                           'sim',
                                           'simPlans',
                                           'newSim',
                                           '$timeout',
                                           'simService',
                                           'ModalService'];

        private static MB: number = 1024 * 1024;
        private static GB: number = SIMModalController.MB * 1024;
        private scope: ISIMModalScope;
        private close: (parameters: IModalResult) => void;
        private $timeout: ng.ITimeoutService;
        private simService: Services.SIMService;
        private modalService: ngModal.IModalService;
        private selectizeSimPlan: Selectize.IApi<string, Models.SimPlan>;
        private selectizeBillingCycle: Selectize.IApi<string, string>;
        private selectizeForDataUnit: Selectize.IApi<string, string>;

        private dataUnitOptions: Common.ISelectizeStringString[] = [
            {
                value: 'MB',
                string: 'MB',
            }, {
                value: 'GB',
                string: 'GB',
            }];
        /**
         * Constructor
         */
        constructor($scope: ISIMModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    title: string,
                    sim: Models.ISIM,
                    simPlans: Models.SimPlan[],
                    newSim: boolean,
                    $timeout: ng.ITimeoutService,
                    simService: Services.SIMService,
                    modalService: ngModal.IModalService) {

            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.simService = simService;
            this.modalService = modalService;

            this.scope = $scope;
            this.scope.title = title;
            this.scope.sim = sim;
            this.scope.simPlans = simPlans;
            this.scope.setInitialData = newSim;
            this.scope.lastDayChecked = false;

            this.close = close;
            this.$timeout = $timeout;

            // selectize elements initialization
            this.selectizeSimPlan = undefined;
            this.selectizeBillingCycle = undefined;
            this.selectizeForDataUnit = undefined;

            // set default value in the select
            if (!sim.billingCycle)
                sim.billingCycle = 1;

            // set default value in the select
            if (!sim.simPlan)
                sim.simPlan = this.scope.simPlans[0];

            this.scope.selectedData =  Utils.humanReadableBytesAsObject(sim.simPlan.dataAmount);
            this.scope.selectedPlan = sim.simPlan;

            this.scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.scope.modalSave = (): void => {
                if (this.scope.selectedPlan &&
                    sim.iccid !== undefined && !isNaN(Number(sim.iccid)) && Utils.lengthRange(parseInt(sim.iccid, 10), 10, 20) &&
                    (this.scope.lastDayChecked || (sim.billingCycle !== undefined && Utils.lengthRange(sim.billingCycle, 1, 30))) &&
                    sim.pin !== undefined && !isNaN(Number(sim.pin)) && Utils.lengthRange(sim.pin, 4) &&
                    (sim.puk === undefined || (!isNaN(Number(sim.puk)) && Utils.lengthRange(sim.puk, 8)))) {

                    sim.billingCycle = this.scope.lastDayChecked ? 31 : sim.billingCycle;
                    sim.simPlan = this.scope.selectedPlan;

                    this.close({
                      sim: sim,
                      newRemainingData: this.scope.setInitialData ?
                        this.scope.dataToBytes() : undefined,
                    });
                }
            };

            this.scope.dataToBytes = (): number => {
                return this.selectizeForDataUnit.getValue() === "MB" ?
                    SIMModalController.MB * this.scope.selectedData.value :
                    SIMModalController.GB * this.scope.selectedData.value;
            };

            this.scope.loadSelectize = (): void => {
                // special array for Selectize rendering
                this.scope.billingCycleOptions = Utils.range(31);
                for (let i: number = 0; i < this.scope.billingCycleOptions.length; i++) {
                    this.scope.billingCycleOptions[i] = {
                        "value": (i + 1).toString(),
                    };
                }

                if (this.selectizeSimPlan !== undefined)
                    this.selectizeSimPlan.destroy();
                if (this.selectizeBillingCycle !== undefined)
                    this.selectizeBillingCycle.destroy();
                if (this.selectizeForDataUnit !== undefined)
                    this.selectizeForDataUnit.destroy();

                this.scope.loadBillingSelectize();
                this.scope.loadPlanSelectize();
                this.scope.loadDataUnitSelectize();
            };

            this.scope.loadPlanSelectize = (): void => {
                let self: Controllers.SIMModalController = this;
                let $select: JQuery = $('#select_sim_plan').selectize(
                    {
                        valueField: 'href',
                        maxItems: 1,
                        onChange: (simPlanHref: string): void => {
                            if (newSim || sim.simPlan && sim.simPlan.href !== simPlanHref)
                                self.scope.setInitialData = true;
                            else if (sim.simPlan)
                                self.scope.setInitialData = false;
                            for (let i: number = 0; i < self.scope.simPlans.length; i++) {
                                if (self.scope.simPlans[i].href === simPlanHref)
                                    self.$timeout(() => {
                                        self.scope.selectedPlan = self.scope.simPlans[i];
                                        // update input and select data values
                                        let newDataPlan: Models.IDataRemaining =
                                            Utils.humanReadableBytesAsObject(self.scope.selectedPlan.dataAmount);
                                        if (self.selectizeForDataUnit)
                                            self.selectizeForDataUnit.setValue(newDataPlan.unit);
                                        self.scope.selectedData.value = newDataPlan.value;
                                    });
                            }
                        },
                        options: self.scope.simPlans,
                        render: {
                            option: (item: Models.ISimPlan, escape: (input: string) => string ): string => {
                                return '<div>' + escape(item.name) +
                                        " (" + escape(item.operatorName) + ")" +
                                        " - <b>" + Utils.humanReadableBytes(item.dataAmount) + "</b>" +
                                       '</div>';
                            },
                            item: (item: Models.ISimPlan, escape: (input: string) => string ): string => {
                                return '<div>' + escape(item.name) +
                                        " (" + escape(item.operatorName) + ")" +
                                        " - <b>" + Utils.humanReadableBytes(item.dataAmount) + "</b>" +
                                       '</div>';
                            },
                        },
                    });
                this.selectizeSimPlan = $select[0].selectize;
                if (this.scope.selectedPlan) {
                    this.selectizeSimPlan.setValue(this.scope.selectedPlan.href);
                }

            };

            this.scope.loadBillingSelectize = (): void => {
                let self: Controllers.SIMModalController = this;
                let $selectBilling: JQuery = $('#sim-billing-cycle').selectize(
                    {
                        labelField: 'value',
                        valueField: 'value',
                        maxItems: 1,
                        onChange: (selectedBillingCycle: string): void => {
                            self.$timeout(() => {
                                self.scope.sim.billingCycle = Number(selectedBillingCycle);
                            });
                        },
                        options: self.scope.billingCycleOptions,
                    });
                this.selectizeBillingCycle = $selectBilling[0].selectize;
                if (this.scope.sim.billingCycle)
                    this.selectizeBillingCycle.setValue(this.scope.sim.billingCycle.toString());
            };

            this.scope.loadDataUnitSelectize = (): void => {
                if (this.selectizeForDataUnit !== undefined)
                    this.selectizeForDataUnit.destroy();
                this.scope.selectedDataUnit = this.scope.selectedData.unit;
                let self: Controllers.SIMModalController = this;
                let $select: JQuery = $('#select_data_unit')
                    .selectize({
                        labelField: 'string',
                        valueField: 'value',
                        maxItems: 1,
                        onChange: (dataUnit: string): void => {
                            for (let i: number = 0; i < self.dataUnitOptions.length; i++)
                                if (self.dataUnitOptions[i].value === dataUnit)
                                    self.$timeout(() => {
                                        self.scope.selectedDataUnit = self.dataUnitOptions[i].value;
                                    });
                        },
                        options: self.dataUnitOptions,
                    });
                this.selectizeForDataUnit = $select[0].selectize;
                if (this.scope.selectedDataUnit)
                    this.selectizeForDataUnit.setValue(this.scope.selectedDataUnit);
            };

            this.scope.disableBillingSelect = (): void => {
                if (this.scope.lastDayChecked)
                    this.selectizeBillingCycle.disable();
                else
                    this.selectizeBillingCycle.enable();
            };
        }
    }
}
